import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const VideoPlay = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 17 16"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M15.4957 10V6C15.4957 2.66667 14.1624 1.33333 10.829 1.33333H6.82902C3.49569 1.33333 2.16235 2.66667 2.16235 6V10C2.16235 13.3333 3.49569 14.6667 6.82902 14.6667H10.829C14.1624 14.6667 15.4957 13.3333 15.4957 10Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.50903 4.74H15.149"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.50903 1.40667V4.64667"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1492 1.40667V4.34667"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.3291 9.63333V8.83333C7.3291 7.80667 8.05577 7.38667 8.94243 7.9L9.63577 8.3L10.3291 8.7C11.2158 9.21333 11.2158 10.0533 10.3291 10.5667L9.63577 10.9667L8.94243 11.3667C8.05577 11.88 7.3291 11.46 7.3291 10.4333V9.63333V9.63333Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

VideoPlay.displayName = 'VideoPlay';
